type Props = {
  label: string
  disabled?: boolean
  type?: "button" | "submit" | "reset"
  mode?: "primary" | "secondary" | "success" | "danger" | "warning" | "info"
  className?: string
  onClick?: (e?: React.MouseEvent) => void
}

const Button = ({
  label,
  disabled = false,
  className,
  onClick,
  type = "button",
  mode = "primary",
}: Props) => {
  const baseClasses = "text-[1.4rem] font-semibold px-4 py-2 h-[4.8rem] rounded-[1.2rem]"
  const modeClasses = {
    primary: "bg-primary text-white",
    secondary: "bg-secondary text-white",
    success: "bg-success text-white",
    danger: "bg-danger text-white",
    warning: "bg-warning text-white",
    info: "bg-info text-white",
  }
  return (
    <button
      className={`${baseClasses} ${modeClasses[mode]} ${className ?? ""} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {label}
    </button>
  )
}

export default Button
